import { useCallback, useState } from 'react';

import { clampWidth, readWidths, writeWidths } from './column-resize';

export interface UseColumnWidthsResult {
  widths: Record<string, number>;
  /** Clamp the px value, update state, and persist the full map. */
  setWidth: (columnId: string, px: number) => void;
}

/** Per-table column widths backed by localStorage (keyed by `gridId`). */
export function useColumnWidths(gridId: string): UseColumnWidthsResult {
  const [widths, setWidths] = useState<Record<string, number>>(() => readWidths(gridId));

  const setWidth = useCallback(
    (columnId: string, px: number) => {
      setWidths((prev) => {
        const next = { ...prev, [columnId]: clampWidth(px) };
        writeWidths(gridId, next);
        return next;
      });
    },
    [gridId],
  );

  return { widths, setWidth };
}
